<template>
  <template v-for="(label, key) in sections">
    <button
      ref="tabs"
      v-if="sectionVisibility[key] !== null"
      :class="{ active: sectionVisibility[key] }"
      @click="scrollToElement(`#toc-${key}`, 75)"
      v-text="label"
    ></button>
  </template>
</template>

<script setup>
import { ref, toValue, watch } from 'vue'
import { useItineraryStore } from '@/stores/itinerary.js'
import { scrollToElement } from '@/helpers/documentHelpers.js'
import { useScroll } from '@vueuse/core'

const {
  sectionVisibility,
  data: {
    itinerary: { relabelAccommodation },
  },
} = useItineraryStore()

const sections = {
  itinerary: `Itinerary`,
  accommodation: relabelAccommodation || 'Accommodation',
  included: `Included`,
  excluded: `Not Included`,
  faq: `FAQ`,
  addon: `Available add-on`,
  'customer-reviews': `All trip reviews`,
}

const tabs = ref([])
const { isScrolling } = useScroll(window)

watch(
  () => [toValue(sectionVisibility), toValue(isScrolling)],
  ([_, scrolling]) => {
    const tab = tabs.value.findLast(el => el.classList.contains('active'))

    if (tab && !scrolling) {
      const parent = tab.parentElement
      parent.scrollTo({
        left: tab.offsetLeft + tab.offsetWidth - parent.clientWidth + 16,
        behavior: 'smooth',
      })
    }
  },
)
</script>

<style lang="scss" scoped>
button {
  display: block;
  padding-block: 16px 14px;
  white-space: nowrap;
  text-transform: uppercase;
  color: $gray;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  border-bottom: 2px solid transparent;

  &:active,
  &.active {
    color: $brand-tertiary;
    border-color: $brand-tertiary;
  }
}
</style>
